package com.parmartechnologies.communication.core.conversation.viewModel

import com.parmartechnologies.core.feature.auth.model.FriendlyProfile
import com.parmartechnologies.core.feature.auth.model.FriendlyUser
import com.parmartechnologies.core.feature.chat.conversation.model.Conversation
import com.parmartechnologies.core.feature.chat.conversation.network.CreateConversationRequest
import com.parmartechnologies.core.feature.chat.conversation.network.FetchBusinessConversationRequest
import com.parmartechnologies.core.feature.chat.conversation.network.FetchConversationRequest
import com.parmartechnologies.core.feature.chat.conversation.network.FindUserRequest
import com.parmartechnologies.core.feature.employee.model.Employee
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.communication.core.conversation.handler.ConversationHandler
import com.parmartechnologies.communication.core.conversation.network.ConversationNetwork
import com.parmartechnologies.communication.core.conversation.repository.ConversationRepository
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.feature.profile.model.Profile
import com.parmartechnologies.storage.constant.KeyConstant.Companion.business
import com.parmartechnologies.storage.table.chat.conversation.ConversationDatabaseTable
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kotlin.time.ExperimentalTime

class ConversationViewModel : AppViewModel() {
    val repository: ConversationRepository = ConversationHandler.shared().repository
    val allConversation: StateFlow<ArrayList<Conversation>>
        get() = repository.allConversation

    val Conversation: StateFlow<Conversation?>
        get() = repository.Conversation

    val newConversation: StateFlow<Conversation>
        get() = repository.newConversation

    val editConversation: StateFlow<Conversation?>
        get() = repository.editConversation

    val profile: StateFlow<FriendlyProfile?>
        get() = repository.profile

    val searchQuery: StateFlow<String>
        get() = repository.searchQuery
    override fun changeSearchQuery(value: String) {
        scope.launch {
            repository.searchQueryState.emit(value)
        }
        performSearch(value)
    }

    fun selectConversation(Conversation: Conversation?) {
        repository.selectConversation(Conversation)
    }

    fun editConversation(Conversation: Conversation?) {
        repository.setEditConversation(Conversation)
    }

    override fun performSearch(value: String) {
        val searchQueryText = value.lowercase()
        scope.launch {
            val filteredResult = repository.allConversation.value.filter { item ->
                item.GroupName.lowercase()
                    ?.contains(searchQueryText) == true || item.GroupName.lowercase()
                    ?.contains(searchQueryText) == true || item.GroupName.lowercase()?.contains(
                    searchQueryText
                ) == true
            } as ArrayList<Conversation>
            repository.allConversationLiveData.emit(filteredResult)
        }
    }

//    fun loadAttendanceFor(Conversation: Conversation){
//        ConversationRepository.allConversationAttendanceLiveData.postValue(arrayListOf())
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            ConversationRepository.allConversationAttendanceLiveData.postValue(DatabaseHandler.shared().database.ConversationAttendanceDao().getAllItemsFor(Conversation._id) as ArrayList<ConversationAttendance>?)
//        }
//    }

    fun editConversationName(value: String) {
        repository.editConversation.value?.GroupName = value
    }


    fun retrieveForUser() {
        loadFromStorage()
        startLoading()
        val request = FetchConversationRequest(
            AuthHandler.shared().UserID,
            ""//repository.LastSyncDate.value
        )
        scope.launch {
            ConversationNetwork().retrieve(request) {
                stopLoading()
                if (it?.payload?.isNotEmpty() == true) {
                    scope.launch {
                        ConversationDatabaseTable().insert(it.payload)
                        loadFromStorage()
                    }
                }
            }
        }
    }

    fun retrieveForBusiness(id:String) {
        loadFromStorage()
        startLoading()
        val request = FetchBusinessConversationRequest(
            id,
            ""//repository.LastSyncDate.value
        )
        scope.launch {
            ConversationNetwork().retrieve(request) {
                stopLoading()
                if (it?.payload?.isNotEmpty() == true) {
                    scope.launch {
                        ConversationDatabaseTable().insert(it.payload)
                        loadFromStorage()
                    }
                }
            }
        }
    }

    fun retrieve() {
        loadFromStorage()
        if(AuthHandler.shared().isLoggedIn()){
            startLoading()
            val request = FetchConversationRequest(
                AuthHandler.shared().UserID,
                ""//repository.LastSyncDate.value
            )
            scope.launch {
                ConversationNetwork().retrieve(request) {
                    stopLoading()
                    if (it?.payload?.isNotEmpty() == true) {
                        scope.launch {
                            ConversationDatabaseTable().insert(it.payload)
                            loadFromStorage()
                        }
                    }
                }
            }
        }
    }

    fun retrieveProfiles(){

    }

    fun createNew(employee: Employee,business:Business) {
        val request = CreateConversationRequest(
            AuthHandler.shared().UserID,
            business._id,
            "",
            listOf(AuthHandler.shared().UserID),
            listOf(AuthHandler.shared().UserID, employee.EmployeeUserID)
        )
        scope.launch {
            ConversationNetwork.shared().createConversation(request){
                println(it)
            }
        }
    }


    fun createNew(user: FriendlyUser,callBack: (Conversation?) -> Unit = {}) {
        val request = CreateConversationRequest(
            AuthHandler.shared().UserID,
            "",
            "",
            listOf(AuthHandler.shared().UserID,user.UserID),
            listOf(AuthHandler.shared().UserID, user.UserID)
        )
        scope.launch {
            ConversationNetwork.shared().createConversation(request){
                callBack(it?.payload)
            }
        }
    }
    fun createNew(profile: Profile,callBack: (Conversation?) -> Unit = {}) {
        val request = CreateConversationRequest(
            AuthHandler.shared().UserID,
            "",
            "",
            listOf(AuthHandler.shared().UserID),
            listOf(AuthHandler.shared().UserID, profile.UserID)
        )
        scope.launch {
            ConversationNetwork.shared().createConversation(request){
                callBack(it?.payload)
            }
        }
    }


    fun insert(Conversation: Conversation) {
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.ConversationDao()
//                .insert(Conversation)
//        }
    }

    fun findUser(dialCode: String, mobile: String, callBack: (FriendlyProfile?) -> Unit) {
        startLoading()
        val request = FindUserRequest(
            "",//UserID as null
            mobile,
            dialCode
        )
        scope.launch {
            ConversationNetwork().findUser(request) {
                stopLoading()
                if (it?.payload?._id?.isNotBlank() == true) {
                    scope.launch {
                        repository.profileLiveData.emit(it.payload)
                    }
                    callBack(it.payload)
                } else {
                    scope.launch {
                        repository.profileLiveData.emit(null)
                    }
                    callBack(null)
                }
            }
        }
    }

//    fun addConversation(Conversation: FriendlyProfile?, callBack: (Boolean) -> Unit) {
//        startLoading()
//        val request = CreateConversationRequest(
//            AuthHandler.shared().UserID,
//            BusinessHandler.shared().repository.business.value._id,
//            Conversation?._id,
//            Conversation?.Gender,
//            Conversation?.Address,
//            Conversation?.Status,
//            Conversation?.EmailID,
//            Conversation?.MobileNumberNumber,
//            Conversation?.DialCode,
//            Conversation?.WhatsApp,
//            Conversation?.Gender,
//            Conversation?.DeviceID,
//            Conversation?.FCMToken,
//            Conversation?.JobTypeId,
//            Conversation?.JobTypeName,
//        )
//        scope.launch {
//            ConversationNetwork().createConversation(request) {
//                stopLoading()
//                if (!it?.payload?._id.isNullOrEmpty()) {
//                    callBack(true)
//                    scope.launch {
//                        ConversationHandler.shared().repository.newConversationLiveData.emit(it!!.payload)
//                    }
//                } else {
//                    callBack(false)
//                }
//            }
//        }
//    }

//    fun updateConversation(
//        callBack: (Boolean) -> Unit
//    ) {
//        val request = editConversation.value?.let {
//            UpdateConversationRequest(
//                it._id,
//                AuthHandler.shared().UserID,
//                BusinessHandler.shared().repository.business.value._id,
//                editConversation.value?.Name ?: "",
//                editConversation.value?.DialCode ?: "",
//                editConversation.value?.MobileNumberNumber ?: "",
//                editConversation.value?.EmailID ?: "",
//                AuthHandler.shared().deviceId,
//                editConversation.value?.IsDeleted,
//                editConversation.value?.JobTypeId,
//                editConversation.value?.JobTypeName,
//            )
//        }
//        request?.let {
//            startLoading()
//            scope.launch {
//                ConversationNetwork().updateConversation(it) { response ->
//                    stopLoading()
//                    if (!response?.payload?._id.isNullOrEmpty()) {
//                        callBack(true)
//                        scope.launch {
//                            ConversationHandler.shared().repository.ConversationLiveData.emit(response!!.payload!!)
//                        }
//                    } else {
//                        callBack(false)
//                    }
//                }
//            }
//        }
//    }

//    fun findUser(mobile: String) {
//
//        val user = FriendlyUser()
//        var request = JSONObject()
//        request.put(KeyConstant.UserID, user._id)
//        request.put(KeyConstant.BusinessID, BusinessHandler.shared().repository.business.value?._id)
//        request.put(KeyConstant.MobileNumberNumber, mobile)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        SocketService.shared().send(SocketEvent.FIND_USER, request)
//    }

    @OptIn(ExperimentalTime::class)
    fun createNewAttendance(
        Conversation: Conversation,
        isPresent: Boolean,
        date: String,
        hours: Float,
        comment: String
    ) {
        val user = FriendlyUser()
//        val request = JSONObject()
//        val business = BusinessHandler.shared().repository.business.value
//        request.put(KeyConstant.UserID, user._id)
//        request.put(KeyConstant.BusinessID, business?._id)
//        request.put(KeyConstant.ConversationUserID, Conversation.ConversationUserID)
//        request.put(KeyConstant.ConversationID, Conversation._id)
//        request.put(KeyConstant.attendanceDate, date)
//        request.put(KeyConstant.isPresent, isPresent)
//        request.put(KeyConstant.hours, hours)
//        request.put(KeyConstant.comment, comment)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        SocketService.shared().send(SocketEvent.ADD_Conversation_ATTENDACE, request)
    }



    private fun loadFromStorage() {
        scope.launch {
            ConversationDatabaseTable().retrieve(AuthHandler.shared().UserID) { data ->
                scope.launch {
                    repository.allConversationLiveData.emit(data as ArrayList<Conversation>)
                }
            }
        }
    }
}